import {Component, Inject, OnInit} from '@angular/core';
import {ArtifactId, DeviceId, IntegrationId, ProjectId} from '@webmate-web-core/shared/types/ids';
import {forkJoin, Observable, of} from 'rxjs';
import {catchError, map, mergeMap, take} from 'rxjs/operators';
import {DeviceService} from '@webmate-web-core/shared/services/device/device.service';
import {DeviceSlot} from '@webmate-web-core/shared/types/devices/device-slot';
import {Device} from '@webmate-web-core/shared/types/devices/device';
import {LogoResolverService} from '@webmate-web-core/shared/services/logo-resolver.service';
import {empty as observableEmpty} from 'rxjs/internal/observable/empty';
import {DeviceSlotService} from '@webmate-web-core/shared/services/device/device-slot.service';
import {WmNotificationService} from '@webmate-web-core/shared/components/notification/wm-notification.service';
import {ModalToolContainerService, WebmateToolConfig} from '../modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from '../modaltoolcontainer/modaltoolcontainer.component';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';


export class DeviceMalfunctionReporterToolConfig implements WebmateToolConfig {
    toolName = 'Device Malfunction Reporter';

    constructor(public deviceId: DeviceId, public projectId: ProjectId) {
    }
}

interface DeviceReporterMalfunctionReporterFormParams {
    message: string;
}

@UntilDestroy()
@Component({
    selector: 'wm-device-malfunction-reporter',
    templateUrl: './device-malfunction-reporter.component.html',
    styleUrls: ['./device-malfunction-reporter.component.less']
})
export class DeviceMalfunctionReporterComponent implements OnInit {

    faInfoCircle = faInfoCircle;

    reportTitle: string = '';
    message: string = '';
    device?: Device = undefined;
    deviceSlot?: DeviceSlot = undefined;
    logoSrc?: string = undefined;
    busySendingReport = false;

    constructor(@Inject(TOOL_CONTAINER_DATA) public data: DeviceMalfunctionReporterToolConfig,
                private deviceService: DeviceService,
                private notificationService: WmNotificationService,
                private platformLogoResolver: LogoResolverService,
                private deviceSlotService: DeviceSlotService,
                private toolService: ModalToolContainerService) {
    }

    ngOnInit() {
        this.deviceService.getDevice$(this.data.deviceId).pipe(mergeMap(device => {
            this.device = device; //update device
            if (this.logoSrc === undefined && this.device.platform !== undefined && this.device.platform.platformType !== 'UNKNOWN' && this.device.properties !== undefined) { //ask the AssetAndBlobService for a representation of the Device if we have one
                return this.platformLogoResolver.getLogoForDevice(this.device);
            } else {
                return of(undefined);
            }
        }), mergeMap(logo => {
            this.logoSrc = logo;
            return this.deviceSlotService.getSlotInProject$(this.device!.slot, this.data.projectId);
        }), untilDestroyed(this)).subscribe(slot => {
            this.deviceSlot = slot;
        });
    }

    reportMalfunction() {
        this.busySendingReport = true;
        this.deviceService.sendMalfunctionReportOfDevice$(this.data.deviceId, this.reportTitle, this.message, this.data.projectId).subscribe(
            next => {
                setTimeout(() => this.toolService.closeLastTool(), 0);
                this.notificationService.toastNotification('Malfunction Report sent successfully! We will contact you soon.');
            },
            err => {
                setTimeout(() => this.toolService.closeLastTool(), 0);
                this.notificationService.toastWarningNotification('Sending Malfunction Report failed!');
            }
        );
    }
}
